import { InjectionToken } from '@angular/core';
import { IRxStore } from '@valhalla/core';

import { IUserSettingsState } from './store/state';

export const STORE_USER_SETTINGS = new InjectionToken<IRxStore<IUserSettingsState>>('STORE_USER_SETTINGS');
